export default __webpack_public_path__ + "static/media/icon-caret-up.d009577b.svg";